export enum BillingPeriod {
  YEARLY = 'YEARLY',

  MONTHLY = 'MONTHLY',
}
